import { render, staticRenderFns } from "./SlideDayTo.vue?vue&type=template&id=c2924d2e&scoped=true&"
import script from "./SlideDayTo.vue?vue&type=script&lang=js&"
export * from "./SlideDayTo.vue?vue&type=script&lang=js&"
import style0 from "./SlideDayTo.vue?vue&type=style&index=0&id=c2924d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2924d2e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Typography: require('/opt/build/repo/components/Typography.vue').default})
